import Droppable from "../../../DnD/Droppable";
import Button from "../../../../../components/Button/Button";
import Icon, {editIcon} from "../../../../../components/Icon/Icon";
import classNames from "classnames";
import {elementAmount} from "../../../../../components/AreaTypes/AreaTypes";

const Area = ({itemIds, settings, childrenItems = [], elementTypes, setEditItemId}) => {
    const className = settings.areaType.split("-")[1];

    const divArray = [...Array(elementAmount[className])];

    return (
        <div className={classNames("area", className)}>
            {divArray.map((_, i) => (
                <div key={i} className="box">
                    <Droppable id={`droppable-${itemIds[i]}`}>
                        {childrenItems.length !== 0 && (
                            childrenItems[i]?.map(child => {
                                const ChildComponent = child.type !== "input" ? elementTypes[child.type] : elementTypes[child.settings.inputType];
                                return (
                                    <div key={child.id} className="item">
                                        <ChildComponent settings={child.settings}/>

                                        {setEditItemId &&
                                            <Button variant="action" onClick={() => setEditItemId(child.id)}>
                                                <Icon svg={editIcon} className="builder"/>
                                            </Button>
                                        }
                                    </div>
                                );
                            })
                        )}
                    </Droppable>
                </div>
            ))}
        </div>
    );
};

export default Area;